
(function () {
  'use strict';

  var TRUCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

  if (window.__z9QuickViewInit) return;
  window.__z9QuickViewInit = true;

  var ALL_DATA = {};
  var overlay, modal;
  var currentProduct = null;
  var selected = [];

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    parseData();
    setupModal();
    bindTriggers();
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('z9-qv-overlay--open')) close();
    });
  }

  
  function parseData(scope) {
    var blocks = (scope || document).querySelectorAll('[data-z9-qv-data]');
    for (var i = 0; i < blocks.length; i++) {
      try {
        var d = JSON.parse(blocks[i].textContent);
        for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) ALL_DATA[k] = d[k];
      } catch (e) {  }
    }
  }

  window.z9QuickView = { ingest: parseData };

  
  function setupModal() {
    var instances = document.querySelectorAll('[data-z9-qv-modal]');
    if (!instances.length) return;
    overlay = instances[0];
    for (var i = 1; i < instances.length; i++) instances[i].parentNode.removeChild(instances[i]);
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    modal = overlay.querySelector('.z9-qv');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { close(); return; }
      if (e.target.closest('.z9-qv__close')) { close(); return; }
      var optBtn = e.target.closest('.z9-qv__opt-btn');
      if (optBtn && currentProduct) { selectOption(optBtn); return; }
      var atcBtn = e.target.closest('.z9-qv__atc');
      if (atcBtn && !atcBtn.disabled) { addFromModal(atcBtn); }
    });
  }

  
  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.z9-qv-trigger');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = t.dataset.z9QvHandle || t.dataset.handle;
      if (handle) open(handle);
    });
  }

  
  function open(handle) {
    if (!overlay || !modal) return;
    overlay.classList.add('z9-qv-overlay--open');
    document.body.style.overflow = 'hidden';
    modal.innerHTML = '<div class="z9-qv__loading"><div class="z9-qv__spinner"></div></div>';

    /* Review stars are Liquid-rendered server-side (same product-reviews snippet
       the collection cards use, fed by Judge.me's reviews.* metafields) and
       fetched in parallel with the product data. Injected into the modal once
       both the markup and the fragment are ready. */
    currentHandle = handle;
    var reviewsPromise = fetch('/products/' + handle + '?section_id=z9-qv-reviews')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        render(data, handle);
        return reviewsPromise.then(function (html) { injectReviews(handle, html); });
      })
      .catch(close);
  }

  var currentHandle = null;
  function injectReviews(handle, html) {
    if (!html || handle !== currentHandle) return;
    var slot = modal.querySelector('[data-z9qv-reviews-slot]');
    if (!slot) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var frag = doc.querySelector('[data-z9qv-reviews]');
    if (frag && frag.innerHTML.replace(/\s/g, '') !== '') slot.innerHTML = frag.innerHTML;
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('z9-qv-overlay--open');
    document.body.style.overflow = '';
  }

  
  function render(data, handle) {
    currentProduct = data;
    currentProduct.__handle = handle;
    var v = data.variants[0];
    selected = (v.options || [v.option1, v.option2, v.option3].filter(Boolean)).slice();

    var bundle = ALL_DATA[handle] || {};
    var swatchMap = bundle.swatches || {};

    var h = '';
    h += '<button class="z9-qv__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>';
    h += '<div class="z9-qv__img"><img id="z9qv-img" src="' + sized(data.featured_image, 600) + '" alt="' + esc(data.title) + '"></div>';
    h += '<div class="z9-qv__info">';
    if (data.vendor) h += '<span class="z9-qv__vendor">' + esc(data.vendor) + '</span>';
    h += '<h3 class="z9-qv__title">' + esc(data.title) + '</h3>';
    h += '<div class="z9-qv__reviews" data-z9qv-reviews-slot></div>';
    h += '<span class="z9-qv__sku" id="z9qv-sku"' + (v.sku ? '' : ' hidden') + '>' + (v.sku ? 'SKU: ' + esc(v.sku) : '') + '</span>';
    h += '<div class="z9-qv__price" id="z9qv-price">' + priceHtml(v) + '</div>';

    if (data.variants.length > 1) {
      h += '<div class="z9-qv__options">';
      data.options.forEach(function (opt, i) {
        var name = typeof opt === 'string' ? opt : (opt.name || '');
        var isColor = isColorOption(name);
        var swatches = swatchMap[name] || null;
        h += '<div class="z9-qv__opt-group' + (isColor ? ' z9-qv__opt-group--swatches' : '') + '"><span class="z9-qv__opt-label">' + esc(name) + '</span><div class="z9-qv__opt-values">';
        var seen = {};
        data.variants.forEach(function (vr) {
          var val = vr.options ? vr.options[i] : vr['option' + (i + 1)];
          if (!val || seen[val]) return;
          seen[val] = true;
          var active = val === selected[i] ? ' z9-qv__opt-btn--active' : '';
          if (isColor) {
            var sw = (swatches && swatches[val]) || {};
            var bg = '';
            if (sw.image) {
              bg = 'background-image:url(\'' + sw.image + '\');background-size:cover;background-position:center;';
            } else {
              bg = 'background-color:' + (sw.color || colorFromValue(val)) + ';';
            }
            h += '<div class="z9-qv__opt-swatch-wrap">';
            h += '<button class="z9-qv__opt-btn z9-qv__opt-btn--swatch' + active + '" data-idx="' + i + '" data-val="' + esc(val) + '" style="' + bg + '" title="' + esc(val) + '" aria-label="' + esc(name) + ': ' + esc(val) + '"></button>';
            if (sw.abbr) h += '<span class="z9-qv__opt-abbr">' + esc(sw.abbr) + '</span>';
            h += '</div>';
          } else {
            h += '<button class="z9-qv__opt-btn' + active + '" data-idx="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
          }
        });
        h += '</div></div>';
      });
      h += '</div>';
    }

    var ss = getSplit(v.id);
    h += '<div class="z9-qv__shipping" id="z9qv-shipping"' + (ss ? '' : ' hidden') + '>';
    if (ss) h += TRUCK_SVG + '<span>' + esc(ss) + '</span>';
    h += '</div>';

    h += '<button class="z9-qv__atc" data-vid="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' + (v.available ? 'ADD TO CART' : 'SOLD OUT') + '</button>';
    h += '<a class="z9-qv__link" href="' + data.url + '">View Full Details</a>';
    h += '</div>';

    modal.innerHTML = h;
  }

  
  function selectOption(btn) {
    var idx = parseInt(btn.dataset.idx, 10);
    var val = btn.dataset.val;
    selected[idx] = val;

    var btns = modal.querySelectorAll('.z9-qv__opt-btn[data-idx="' + idx + '"]');
    for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('z9-qv__opt-btn--active', btns[i].dataset.val === val);

    var match = findVariant();
    if (!match) return;

    var atc = modal.querySelector('.z9-qv__atc');
    atc.dataset.vid = match.id;
    atc.disabled = !match.available;
    atc.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
    atc.classList.remove('z9-qv__atc--added');

    modal.querySelector('#z9qv-price').innerHTML = priceHtml(match);

    if (match.featured_image) {
      modal.querySelector('#z9qv-img').src = sized(match.featured_image.src, 600);
    }

    var skuEl = modal.querySelector('#z9qv-sku');
    if (skuEl) {
      if (match.sku) { skuEl.textContent = 'SKU: ' + match.sku; skuEl.hidden = false; }
      else { skuEl.textContent = ''; skuEl.hidden = true; }
    }

    var shipEl = modal.querySelector('#z9qv-shipping');
    if (shipEl) {
      var st = getSplit(match.id);
      if (st) { shipEl.innerHTML = TRUCK_SVG + '<span>' + esc(st) + '</span>'; shipEl.hidden = false; }
      else { shipEl.innerHTML = ''; shipEl.hidden = true; }
    }
  }

  function findVariant() {
    if (!currentProduct) return null;
    for (var i = 0; i < currentProduct.variants.length; i++) {
      var vr = currentProduct.variants[i];
      var opts = vr.options || [vr.option1, vr.option2, vr.option3].filter(Boolean);
      var ok = true;
      for (var j = 0; j < selected.length; j++) { if (opts[j] !== selected[j]) { ok = false; break; } }
      if (ok) return vr;
    }
    return null;
  }

  
  function addFromModal(btn) {
    var vid = btn.dataset.vid;
    var props = getSplit(vid) ? { 'Split Shipping': getSplit(vid) } : null;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'ADDING...';

    addToCart(vid, props, function (ok) {
      if (ok) {
        btn.classList.add('z9-qv__atc--added');
        btn.textContent = 'ADDED ✓';
        setTimeout(function () { close(); }, 700);
      } else {
        btn.disabled = false;
        btn.textContent = orig;
      }
    });
  }

  function addToCart(vid, properties, cb) {
    var body = { id: vid, quantity: 1 };
    if (properties) body.properties = properties;

    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      cartEl.setActiveElement(document.activeElement);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) { cb(false); return; }
        if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'z9-quick-view', productVariantId: String(vid), cartData: data });
        }
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(data);
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        }
        cb(true);
      })
      .catch(function () { cb(false); });
  }

  
  function getSplit(vid) {
    if (!currentProduct) return '';
    var bundle = ALL_DATA[currentProduct.__handle] || {};
    var splitMap = bundle.split || {};
    var t = splitMap[String(vid)] || '';
    return typeof t === 'string' ? t : '';
  }

  function isColorOption(name) {
    var n = String(name || '').toLowerCase();
    return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('finish') !== -1;
  }

  function colorFromValue(val) {
    var clean = String(val || '').split('(')[0].trim();
    var parts = clean.split(' ');
    return (parts[parts.length - 1] || '').toLowerCase();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function sized(url, size) {
    if (!url) return '';
    return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    var f = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/g, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  function priceHtml(v) {
    var h = '<span class="z9-qv__price-current">' + formatMoney(v.price) + '</span>';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      h += '<span class="z9-qv__price-compare">' + formatMoney(v.compare_at_price) + '</span>';
    }
    return h;
  }
})();
